import { ISession } from './../../../models/session';
import { Component, AfterContentInit, TemplateRef } from '@angular/core';
import { IPlugin, ICategory } from '../../../models/plugin';
import { PluginsService } from '../plugins.service';
import { SessionsService } from '../../sessions/sessions.service';

@Component({
  selector: 'plugins-modal',
  templateUrl: './plugin-modal.component.html',
  styleUrls: ['../plugins.scss']
})
export class PluginModalComponent implements AfterContentInit {
  public bsModalRef;
  public plugin: IPlugin;
  public session: ISession;

  constructor(private pluginsService: PluginsService, public sessionsService: SessionsService) {}

  togglePlugin(plugin: IPlugin, state: boolean) {
    this.pluginsService.togglePlugin(plugin, this.session, state).subscribe(status => {
      plugin.isActivated = status.isActivated;
    });
  }
  ngAfterContentInit() {
    const tooltip = () => jQuery('[data-toggle="tooltip"]').tooltip();
    // wait for next tick because data is not yet loaded
    setTimeout(tooltip, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/plugins/modal/plugin-modal.component.ts